export default __webpack_public_path__ + "dbfd9bd5a9432256196e5ed07cb1f4f9.png";